module.exports = __webpack_public_path__ + "img/Arthur.1cfb2f6d.jpg";